import { Redirect } from 'react-router-dom';
import { RedirectTo } from '../utils/redirectTo';

const ProtectedRouteNotFound = (props) => {
  return <Redirect to={RedirectTo.dashboard} />
};

export default ProtectedRouteNotFound;
